import React from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';
import RailTooltip from './RailTooltip';

/** Classes shared by nav links and the rail's Shipments button, so they look and behave alike. */
export function navItemClass({ isActive, collapsed, nested = false }) {
  return cn(
    'nav-item group relative mt-0.5 flex w-full items-center gap-3 rounded-xl text-sm font-medium transition-colors duration-150',
    collapsed ? 'justify-center px-2 py-2.5' : 'px-3 py-2',
    nested && !collapsed && 'pl-10',
    isActive
      ? 'nav-item--active text-foreground'
      : 'text-muted-foreground hover:bg-secondary hover:text-foreground'
  );
}

export default function NavItem({
  icon: Icon,
  label,
  to,
  collapsed = false,
  nested = false,
  end = false,
  badge = null,
  onClick,
}) {
  const link = (
    <NavLink
      to={to}
      end={end}
      onClick={onClick}
      aria-label={collapsed ? label : undefined}
      className={({ isActive }) => navItemClass({ isActive, collapsed, nested })}
    >
      {({ isActive }) => (
        <>
          {/* Active item is a raised pill (index.css: NAV); the icon carries the brand colour. */}
          {Icon && (
            <Icon
              className={cn('flex-shrink-0', collapsed ? 'w-5 h-5' : 'w-4 h-4', isActive && 'text-primary')}
              aria-hidden="true"
            />
          )}
          {!collapsed && <span className="flex-1 truncate">{label}</span>}
          {!collapsed && badge != null && (
            <span className="ml-auto rounded-full bg-primary/15 px-2 py-0.5 text-xs font-semibold text-accent-foreground">
              {badge}
            </span>
          )}
        </>
      )}
    </NavLink>
  );

  // Rail: the name shows as a floating label outside the sidebar (see RailTooltip). The trigger is a
  // wrapper, not the NavLink itself: Radix merges className as a string, and NavLink's className is
  // a function - merged, it lost all its classes (the rail icons fell out of alignment).
  return collapsed ? (
    <RailTooltip label={label}>
      <div className="w-full">{link}</div>
    </RailTooltip>
  ) : link;
}
